"use strict";

var Model = require("../types/Model.js");

module.exports = Model({
	name: "feedbackmodal",
	init: init,
	triggers: triggers,

	_feedbackData: []
});

function init(){
	this.push(false);
}

function triggers() {
	return {
		"hide": hide,
		"show": show,
		"update": handle_updated
	};
}

function show(data){
	var feedbackItem = data;

	var feedbackTitle = feedbackItem.title || "feedback.generic";
	var progressItems = feedbackItem.items || "load";

	var feedbackData = {
		complete: false,
		title: feedbackTitle,
		progressItems: progressItems
	};

	this._feedbackData = feedbackData;
	this.push(feedbackData);
}

function hide(){
	this.push(false);
}

function handle_updated(data){
	var currentData = this.data;
	Object.keys(data).map(function(updatingItem){
		if( currentData && currentData["progressItems"]) {
			currentData["progressItems"][updatingItem] = data[updatingItem];
		}
	});
	this.push(currentData);
}